import { Card } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  isRecoRobot: boolean;
  children: React.ReactNode;
};
const ListWrapper = ({ isRecoRobot, children }: Props) => {
  return isRecoRobot ? (
    <div className={cn('mt-2 flex h-full flex-col overflow-hidden p-3')}>
      {children}
    </div>
  ) : (
    <Card
      className={'flex w-full overflow-hidden'}
      contentClassName="p-3 w-full"
    >
      {children}
    </Card>
  );
};

export default ListWrapper;
